export default __webpack_public_path__ + "static/media/WNo.8-6.3aa00779.jpg";